var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.responsive
    ? _c(
        "div",
        { staticClass: "dropdown dropdown-submenu clickable wide px-4" },
        [
          _c(
            "a",
            {
              staticClass: "btn btn-white",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleShowTooltip.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("application.listing.addToBoard")) +
                  "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c("boards-dropdown", {
            attrs: { boards: _vm.BOARDS },
            on: { select: _vm.handleBoardSelect },
          }),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "dropleft dropdown-submenu",
          on: {
            mouseenter: _vm.handleShowTooltip,
            mouseleave: _vm.handleHideTooltip,
          },
        },
        [
          _c(
            "a",
            {
              staticClass: "dropdown-item dropdown-toggle clickable",
              attrs: { "data-toggle": "dropdown" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("application.listing.addToBoard")) +
                  "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c("boards-dropdown", {
            attrs: { boards: _vm.BOARDS },
            on: { select: _vm.handleBoardSelect },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }